class ProductEngraving {
	constructor() {
		this.selectors = {
			toggleModal: '.engraving-button__toggle-modal',
			triggerPersonalisation: '.trigger-personalisation',
			triggerParrent: '.engraving-button',
			modalPersonalisation: '.product-engraving',
			defaultAddEngraving: 'a[data-text].product-engraving__button',
			buttonsFont: '.product-engraving__font',
			engravingInput: '.product-engraving__input-selector',
			engravingButton: '.product-engraving__button',
			engravingText: '.product-engraving__preview',
			engravingTextLetters: '.product-engraving__letter',
			engravingMaxLength: '.product-engraving__max-number-characters',
			engravingDetails: '#engravingDetails',
			addedEngraving: '.engraving-added',
			removeEngravingButton: '.engraving-button__remove-added-engraving',
			productForm: 'form[data-product-form].product-form',
			addToCart: '.product__submit__item button[data-add-to-cart]',
			body: "body",
		};

		this.elements = {
			toggleModalButtons: document.querySelectorAll(
				this.selectors.toggleModal
			),
			triggerPersonalisation: document.querySelector(
				this.selectors.triggerPersonalisation
			),
			triggerPersonalisationParent: document.querySelector(
				this.selectors.triggerParrent
			),
			modalPersonalisation: document.querySelector(
				this.selectors.modalPersonalisation
			),
			buttonsFont: document.querySelectorAll(this.selectors.buttonsFont),
			engravingInput: document.querySelector(
				this.selectors.engravingInput
			),
			defaultAddEngraving: document.querySelector(this.selectors.defaultAddEngraving).dataset.text,
			engravingButton: document.querySelector(
				this.selectors.engravingButton
			),
			engravingText: document.querySelector(this.selectors.engravingText),
			engravingTextLetters: document.querySelectorAll(
				this.selectors.engravingTextLetters
			),
			engravingMaxLength: document.querySelector(
				this.selectors.engravingMaxLength
			),
			removeEngravingButton: document.querySelector(
				this.selectors.removeEngravingButton
			),
			personalisationVariantId: document.querySelector(
				this.selectors.triggerParrent
			).dataset.personalisationId,
			addItemToCart: document.querySelector(this.selectors.addToCart),
			body: document.querySelector(this.selectors.body),

		};

		this.classes = {
			modalVisible: 'product-engraving--visible',
			selectedFont: 'product-engraving__font--selected',
			engravingPreview: 'product-engraving__preview',
			engravingPreviewLetter: 'product-engraving__letter',
			engravingPreviewLetters: 'product-engraving__letters',
			buttonLoad: 'vm-button--loading',
			engravingAdded: 'engraving-added',
			engravingButon: 'trigger-personalisation',
			disabled: 'disabled',
			displayNone: 'display--none',
			fixedBody: "fixed-body",
		};

		this.formData;
	}

	init() {
		window.currentProductPersonalisation = {
			enabled: false,
			variantId: `${this.elements.personalisationVariantId}`,
			text: '',
			font: 'Didot',
		};

		this.addListeners();
	}

	addListeners() {
		// Toggle modal (close/open)
		this.elements.toggleModalButtons.forEach((button) =>
			button.addEventListener('click', (event) => {
				event.preventDefault();
				this.elements.modalPersonalisation.classList.toggle(
					this.classes.modalVisible
				);
				this.elements.body.classList.toggle(this.classes.fixedBody);

				if (
					!document.querySelector(this.selectors.addedEngraving) &&
					button.classList.contains(this.classes.engravingButon)
				) {
					this.elements.engravingInput.value = '';
				}
				console.log('clicked');
			})
		);

		this.elements.buttonsFont.forEach((item) => {
			item.addEventListener('click', () => this.handleFontChange(item));
		});

		this.elements.engravingInput.addEventListener('keyup', (event) =>
			this.handleTextChange(event)
		);

		this.elements.engravingButton.addEventListener('click', (event) => {
			event.preventDefault();
			currentProductPersonalisation.enabled = true;
			currentProductPersonalisation.text =
				this.elements.engravingInput.value;

			this.elements.modalPersonalisation.classList.toggle(
				this.classes.modalVisible
			);
			
			this.elements.body.classList.toggle(this.classes.fixedBody);

			if (document.querySelector(this.selectors.addedEngraving)) {
				this.updatePersonalisation(currentProductPersonalisation.text, currentProductPersonalisation.font);
			} else {
				this.addPersonalisation(currentProductPersonalisation.text, currentProductPersonalisation.font);
			}
		});

		this.elements.removeEngravingButton.addEventListener(
			'click',
			async (event) => {
				event.preventDefault();
				await this.removePersonalisation();
			}
		);

		this.elements.addItemToCart.addEventListener('click', async (event) => {
			event.preventDefault();
			await this.resetPersonalization();
		})
	}

	updateUI(method) {

		if (method == 'added') {
			this.elements.removeEngravingButton.classList.remove(
				this.classes.displayNone
			);
			this.elements.triggerPersonalisationParent
				.querySelector('span')
				.classList.add(this.classes.engravingAdded);
			this.elements.engravingButton.classList.remove(
				this.classes.buttonLoad
			);
			this.elements.engravingButton.classList.remove(
				this.classes.disabled
			);
			this.elements.engravingButton.textContent =
				'Modify Existing Engraving';
			this.elements.triggerPersonalisation.textContent =
				'Modify';
			this.elements.modalPersonalisation.classList.remove(
				this.classes.modalVisible
			);
		} else if (method == 'removed') {
			this.elements.removeEngravingButton.classList.add(
				this.classes.displayNone
			);
			this.elements.engravingButton.classList.add(
				this.classes.buttonLoad
			);
			this.elements.engravingButton.classList.add(this.classes.disabled);
			this.elements.triggerPersonalisation.textContent = 'Add Engraving';
			this.elements.engravingButton.textContent = this.elements.defaultAddEngraving;
			if(document.querySelector(this.selectors.addedEngraving)){
				document
				.querySelector(this.selectors.addedEngraving)
				.classList.remove('engraving-added');
			}
			this.elements.engravingInput.value = '';
			currentProductPersonalisation.text = '';
			currentProductPersonalisation.font = '';
			this.elements.buttonsFont.forEach((item) =>
				item.classList.remove(this.classes.selectedFont)
			);
			this.elements.buttonsFont[0].classList.add(
				this.classes.selectedFont
			);
			this.elements.engravingTextLetters.forEach(
				(item) => (item.innerHTML = '')
			);
			this.elements.engravingText.innerHTML = '';
		} else {
			this.elements.engravingButton.classList.add(
				this.classes.buttonLoad
			);
			this.elements.modalPersonalisation.classList.remove(
				this.classes.modalVisible
			);
		}
	}

	handleFontChange(fontContainer) {
		this.elements.buttonsFont.forEach((item) =>
			item.classList.remove(this.classes.selectedFont)
		);
		fontContainer.classList.add(this.classes.selectedFont);

		for (let i = 0; i < this.elements.buttonsFont.length; i++) {
			if (
				this.elements.buttonsFont[i].classList.contains(
					this.classes.selectedFont
				)
			) {
				let selectedButton = i;

				switch (selectedButton) {
					case 0:
						this.elements.engravingText.className = '';
						this.elements.engravingText.classList.add(
							this.classes.engravingPreview + '--font-Didot',
							this.classes.engravingPreview
						);

						currentProductPersonalisation.font = 'Didot';
						break;
					case 1:
						this.elements.engravingText.className = '';
						this.elements.engravingText.classList.add(
							this.classes.engravingPreview + '--font-Bodoni',
							this.classes.engravingPreview
						);
						currentProductPersonalisation.font = 'Bodoni';
						break;
					case 2:
						this.elements.engravingText.className = '';
						this.elements.engravingText.classList.add(
							this.classes.engravingPreview + '--font-George',
							this.classes.engravingPreview
						);
						currentProductPersonalisation.font = 'George';
						break;
					case 3:
						this.elements.engravingText.className = '';
						this.elements.engravingText.classList.add(
							this.classes.engravingPreview + '--font-House',
							this.classes.engravingPreview
						);
						currentProductPersonalisation.font = 'House';
						break;
					default:
						break;
				}
				if (this.elements.engravingTextLetters) {
					this.elements.engravingText.classList.add(
						this.classes.engravingPreviewLetters
					);
				}
			}
		}
	}

	handleTextChange(el) {
		const textInput = el.target;

		const textLength = textInput.value.length;
		this.elements.engravingButton.classList.remove(this.classes.disabled);

		if (this.elements.engravingTextLetters.length > 0) {
			const lettersInput = textInput.value.split('');
			this.elements.engravingTextLetters.forEach(
				(item) => (item.innerHTML = '')
			);

			let iterateStar = (startingPoint) => {
				for (let i = 0; i < lettersInput.length; i++, startingPoint++) {
					this.elements.engravingTextLetters[
						startingPoint
					].innerHTML = lettersInput[i];
				}
			};

			switch (true) {
				case textLength < 2:
					iterateStar(4);
					break;
				case textLength < 4:
					iterateStar(3);
					break;
				case textLength < 6:
					iterateStar(2);
					break;
				case textLength < 8:
					iterateStar(1);
					break;
				case textLength < 10:
					iterateStar(0);
					break;
				default:
					iterateStar(0);
					break;
			}
		} else {
			if (textLength <= this.elements.engravingMaxLength.innerHTML) {
				this.elements.engravingText.innerHTML = textInput.value;
			}
		}

		currentProductPersonalisation.text = textInput.value;
	}

	addPersonalisation(text, font) {
		const productForm = document.querySelector(this.selectors.productForm);
		productForm.querySelector("input[name='properties[Engraving text]']")
			? productForm.querySelector("input[name='properties[Engraving text]']").remove()
			: '';

		productForm.querySelector("input[name='properties[Engraving font]']")
			? productForm.querySelector("input[name='properties[Engraving font]']").remove()
			: '';		

		if (text) {
			const inputText = document.createElement('input');
			inputText.type = 'hidden';
			inputText.name = 'properties[Engraving text]';
			inputText.value = text;
			productForm.appendChild(inputText);
			productForm.setAttribute('data-product-additional-property-engraving-text', text);

			const selectedFont = document.createElement('input');
			selectedFont.type = 'hidden';
			selectedFont.name = 'properties[Engraving font]';
			selectedFont.value = font;
			productForm.appendChild(selectedFont);
			productForm.setAttribute('data-product-additional-property-engraving-font', font);

			this.updateUI('added');
		} else {
			productForm.removeAttribute('data-product-additional-property-engraving-text', '');
			productForm.removeAttribute('data-product-additional-property-engraving-font', '');
		}		
	}

	async removePersonalisation() {
		const productForm = document.querySelector(this.selectors.productForm);
		productForm.querySelector("input[name='properties[Engraving text]']")
				? productForm.querySelector("input[name='properties[Engraving text]']").remove()
				: '';

		productForm.querySelector("input[name='properties[Engraving font]']")
				? productForm.querySelector("input[name='properties[Engraving font]']").remove()
				: '';	

		productForm.removeAttribute('data-product-additional-property-engraving-text', '');
		productForm.removeAttribute('data-product-additional-property-engraving-font', '');				
		this.updateUI('removed');
		this.elements.removeEngravingButton.textContent = 'Remove';
			
	}

	async resetPersonalization(){
		setTimeout(() => {
		this.removePersonalisation();
		}, 1500);
	}

	async updatePersonalisation(text, font) {
		this.addPersonalisation(text, font);
	}
}

window.addEventListener('load', () => {
	new ProductEngraving().init();
});
